import { render, staticRenderFns } from "./KpiMonitor.vue?vue&type=template&id=154c9160&scoped=true"
import script from "./KpiMonitor.vue?vue&type=script&lang=js"
export * from "./KpiMonitor.vue?vue&type=script&lang=js"
import style0 from "./KpiMonitor.vue?vue&type=style&index=0&id=154c9160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c9160",
  null
  
)

export default component.exports